import request from '@/utils/request'

// 删除步骤
export const delStep = (data) => {
    return request.get('/api/evaluationstep/delStep', data)
}
// 编辑步骤
export const editStep = (data) => {
    return request.post('/api/evaluationstep/editStep', data)
}
// 根据项目编码获取文档列表
export const getDocuments = (data) => {
    return request.get('/api/evaluationstep/getDocuments', data)
}
// 获取计算基准价时采用的报价项
export const getQuoteItem = (data) => {
    return request.get('/api/evaluationstep/getQuoteItem', data)
}
// 根据标段id获取步骤列表
export const getStepListBySectionId = (data) => {
    return request.get('/api/evaluationstep/getStepListBySectionId', data)
}
// 分页获取步骤
export const getStepPage = (data) => {
    return request.get('/api/evaluationstep/getStepPage', data)
}
// 保存步骤
export const saveStep = (data) => {
    return request.post('/api/evaluationstep/submitStepList', data)
}
// 获取步骤类型
export const getStepTypeList = () => {
    return request.get('/api/evaluationstep/getStepTypeList')
}
//根据项目编码获取标段列表
export const getSectionList = (data) => {
    return request.get('/api/evaluationstep/getSectionList', data)
}
// 通过式评审步骤保存
export const addPassReview = (data) => {
    return request.post('/api/evaluationstep/savePassReview', data)
}
//打分式评审步骤保存
export const addScoreReview = (data) => {
    return request.post('/api/evaluationstep/saveScoreReview', data)
}
//保存计算基准价步骤
export const saveBasePrice = (data) => {
    return request.post('/api/evaluationstep/saveBasePrice', data)
}
//获取报价基准价步骤列表
export const getBasePriceList = (data) => {
    return request.get('/api/evaluationstep/getCalculateBasePriceStepList', data)
}
//保存报价得分步骤
export const saveQuotationScoreStep = (data) => {
    return request.post('/api/evaluationstep/saveQuotationScoreStep', data)
}
//保存可选步骤
export const saveOptionalStep = (data) => {
    return request.post('/api/evaluationstep/saveOptionalStep', data)
}
//推荐候选人
export const saveRecommendStep = (data) => {
    return request.post('/api/evaluationstep/saveRecommendStep', data)
}
//获取步骤详情
export const getStepDetailByStepId = (data) => {
    return request.get('/api/evaluationstep/getStepDetailByStepId', data)
}
//获取提交状态
export const getSubmitStatus = (sectionId) => {
    return request.get('/api/evaluationstep/getSubmitStatus?sectionId='+sectionId)
}

//根据模板生成评标办法
export const createStepByModel = (data) => {
    return request.post('/api/evaluationstep/createStepByModel', data)
}

//分页获取项目列表(带标段)
export const getProjectSectionList = (data) => {
    return request.post('/api/agent/project/getProjectSectionList', data)
}
//复制
export const copyStep = (data) => {
    return request.get('/api/evaluationstep/copy', data)
}


// 删除


//删除通过式评审项
export const delPassStepViewItem = (data) => {
    return request.get('/api/evaluationstep/delPassStepViewItem', data)
}

//删除打分式评审项
export const delScoreStepViewItem = (data) => {
    return request.get('/api/evaluationstep/delScoreStepViewItem', data)
}
//删除基准价删除项
export const delBaseStepRemoveItem = (data) => {
    return request.get('/api/evaluationstep/delBaseStepRemoveItem', data)
}

